import React from 'react';
export const Footer = () => {
  return <footer className="bg-base py-12 border-t border-pink-medium" data-id="element-105">
      <div className="container mx-auto px-6 max-w-7xl flex flex-col items-center text-center" data-id="element-106">
        <div className="font-serif text-2xl font-bold text-text-main mb-6" data-id="element-107">
          Glow Skin <span className="text-fuchsia italic" data-id="element-108">PRO KIT</span>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-text-muted mb-8" data-id="element-109">
          <a href="#" className="hover:text-fuchsia transition-colors" data-id="element-110">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-fuchsia transition-colors" data-id="element-111">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-fuchsia transition-colors" data-id="element-112">
            Contacto
          </a>
        </div>

        <div className="text-xs text-text-muted/60" data-id="element-113">
          <p className="mb-2" data-id="element-114">
            © {new Date().getFullYear()} Glow Skin PRO KIT. Todos los derechos
            reservados.
          </p>
          <p data-id="element-115">Hecho con ♡ para mujeres emprendedoras</p>
        </div>

        <p className="text-[10px] text-text-muted/40 mt-8 max-w-3xl mx-auto leading-relaxed" data-id="element-116">
          Descargo de responsabilidad: Los resultados pueden variar de persona a
          persona. Este programa tiene fines educativos. La práctica de
          procedimientos estéticos inyectables está regulada por las leyes de
          cada país/estado; es responsabilidad de la alumna verificar la
          normativa local aplicable a su profesión antes de ejercer.
        </p>
      </div>
    </footer>;
};